<template>
  <div class="job-list__container" v-if="groupedJobs && groupedJobs.length > 0">
    <Slider autoSlidingDisabled="true" class="job-slider" v-if="!isMobile">
      <template v-for="(job, index) in groupedJobs">
        <Job
          v-bind:job="job"
          v-bind:sponsorCategory="sponsorCategory"
          v-bind:key="job.id"
          v-bind:isLogoVisible="isLogoVisible"
          v-on:openModal="onJobClick"
          v-bind:index="index"
        />
      </template>
    </Slider>
    <div class="scrollable-slider" v-else>
      <template v-for="(job, index) in groupedJobs">
        <Job
          v-bind:job="job"
          v-bind:sponsorCategory="sponsorCategory"
          v-bind:key="job.id"
          v-bind:isLogoVisible="isLogoVisible"
          v-on:openModal="onJobClick"
          v-bind:index="index"
        />
      </template>
    </div>
    <transition name="fade">
      <JobModal
        v-if="isModalView"
        v-bind:job="groupedJobs[modalIndex]"
        v-bind:currentIndex="modalIndex"
        v-bind:maxIndex="groupedJobs.length - 1"
        v-on:nextJob="onNextJob"
        v-on:previousJob="onPreviousJob"
        v-on:close="onClose"
      />
    </transition>
  </div>
</template>

<script>
import { deviceHandling } from '@/mixins.js';
import { groupBy, shuffleArray } from '@/config.js';

import JobModal from '@/components/landing-page/JobModal.vue';
import Job from '@/components/landing-page/Job.vue';
import Slider from '@/components/app/Slider';

export default {
  name: 'JobList',
  mixins: [deviceHandling],
  data() {
    return {
      modalIndex: 0,
      isModalView: false,
      body: {},
    };
  },
  props: {
    jobs: Array,
    isLogoVisible: Boolean,
    sponsorCategory: String,
  },
  components: {
    Job,
    JobModal,
    Slider,
  },
  mounted() {
    this.body = document.querySelector('body');
  },
  computed: {
    groupedJobs() {
      if (!this.jobs) {
        return null;
      }

      const jobsBySponsor = groupBy(this.jobs, 'sponsor');

      const shuffledGroups = shuffleArray(Object.values(jobsBySponsor));
      const groupedJobs = shuffledGroups.reduce((acc, cur) => acc.concat(cur), []);

      return groupedJobs;
    },
  },
  methods: {
    onJobClick: function(index) {
      this.modalIndex = index;
      this.isModalView = true;
      this.body.style.overflowY = 'hidden';
    },
    onNextJob: function() {
      if (this.groupedJobs.length - 1 > this.modalIndex) this.modalIndex++;
    },
    onPreviousJob: function() {
      if (this.modalIndex > 0) this.modalIndex--;
    },
    onClose: function() {
      this.isModalView = false;
      this.body.style.overflowY = 'unset';
    },
  },
};
</script>

<style>
.job-list__container {
  margin-bottom: -75px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease-in-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.scrollable-slider {
  display: flex;
  overflow: auto;
}
</style>
